import _ from 'lodash';
import moment from 'moment';
import {
  call,
  select,
  put
} from 'redux-saga/effects';
import loader from '../loader/loader';
import {mapGen} from '../helpers';
import {normalizeData} from '../../redux/modules/dataProvider/dataProvider';
import dataConfig from '../../redux/modules/dataProvider/dataConfig';

class dataProvider {

  *load(callConfig, loaderConfig) {

    function* buildParallelCalls(calls, state) {
      return yield mapGen(calls, function*(config) {
        const stateKey = _.get(config, 'state');
        const stateData = _.get(state, _.get(config, 'stateCheck', dataConfig[stateKey].state));
        const message = _.get(config, 'spinnerMessage', dataConfig[stateKey].message);
        const spinnerMessage = _.isFunction(message) ? yield message() : message;
        const param = _.get(config, 'param');
        const computedParam = _.isFunction(param) ? yield param() : param;
        const alwaysCall = _.get(config, 'alwaysCall', false);

        if (!_.get(stateData, _.get(config, 'loadCheck', 'loaded'), false) || alwaysCall) {
          return call(loader.request, dataConfig[stateKey].endpoint(computedParam), {spinnerMessage, useGlobalSpinner: false, ...loaderConfig});
        } else {
          return call(() => false);
        }
      });
    }

    function* updateState(endpointData, localCallConfig) {
      // need to use a loop because yield doesn't work inside another function
      for (let i=0; i < endpointData.length; i++) {
        endpointData[i] ? yield put(normalizeData(
          _.get(localCallConfig[i], 'state'),
          endpointData[i],
          {
            loaded: true,
            persistExpiresAt: moment().add(20, 'minute').toDate()
          }
        )) : null;
      }
    }

    const state = yield select();

    try {

      // Loop through call config and make calls/update state for each
      for (let i=0; i < callConfig.length; i++) {
        const calls = _.isArray(callConfig[i]) ? callConfig[i] : [callConfig[i]];
        const endpoints = yield buildParallelCalls(calls, state);
        const endpointData = yield endpoints;

        yield updateState(endpointData, calls);
      }
      return true;

    } catch(e) {
      //console.log(e);
      return false;
    }
  }
}

//Ensure only a singleton is exported
const instance = new dataProvider();

export default instance;



/** WEBPACK FOOTER **
 ** ./client/util/dataProvider/dataProvider.js
 **/